import { Build, getAssetPath } from '@stencil/core';

/**
 * Resolve a reference to a static asset that lives under the `assets` root.
 *
 * Author paths WITHOUT the `assets` segment and without a CDN host — e.g.
 * `'dochub/rating-star.svg'` or `'/dochub/rating-star.svg'`. A leading
 * `./`, `../`, `/` and an optional `assets/` prefix are all tolerated, so
 * legacy `'/assets/dochub/x.svg'` keeps working.
 *
 * - **Client:** resolves against Stencil's `resourcesUrl` (rewritten to
 *   `${CDN}/build/` by the inline loader), yielding `${CDN}/assets/...`.
 * - **Server (hydrate):** returns a root-relative `/assets/...` path. The SSR
 *   asset rewriter (`rewriteRelativeAssetUrls`) upgrades it to the absolute CDN
 *   URL in the final HTML pass.
 *
 * Crucially, on the server `Build.isBrowser` is statically `false`, so the
 * `getAssetPath` branch is removed at build time. That makes this helper safe
 * to call at module top-level — unlike `getAssetPath`, which throws
 * `TypeError: Invalid URL` during SSR when `resourcesUrl` is not yet set.
 */
export function assetUrl(path: string): string {
  const clean = path
    .replace(/^(\.\.?\/)+/, '')
    .replace(/^\//, '')
    .replace(/^assets\//, '');

  if (Build.isBrowser) {
    return getAssetPath(`../assets/${clean}`);
  }

  return `/assets/${clean}`;
}
